import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'
import axios from 'axios'
import {API_BASE_URL} from '@/constants'

Vue.use(AclInstaller)

let initialRole = 'ROLE_VIEWER'
console.log(localStorage.getItem('userRole'));
if(localStorage.getItem('userRole')) initialRole = localStorage.getItem('userRole')

let  highestRole = function (roles){
  let ordered = {};
  ordered = roles.sort(function(a, b) {
    return (a.id) - (b.id);
  });
  return ordered[0].name;
}
export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/error-404",
  // notfound: {
  //   path: '/error',
  //   forwardQueryParams: true,
  // },
  router,
  acceptLocalRules: true,
  globalRules: {
    hasRoleAdmin: new AclRule('ROLE_ADMIN').generate(),
    hasRoleCenter: new AclRule('ROLE_ADMIN').or('ROLE_CENTER').generate(),
    hasRoleSuperVisor: new AclRule('ROLE_ADMIN').or('ROLE_CENTER').or('ROLE_SUPERVISOR').generate(),
    hasRoleAdminOrSuperVisor: new AclRule('ROLE_ADMIN').or('ROLE_SUPERVISOR').generate(),
    hasRoleOnlySuperVisor: new AclRule('ROLE_SUPERVISOR').generate(),
    hasRoleObserb: new AclRule('ROLE_ADMIN').or('ROLE_CENTER').or('ROLE_SUPERVISOR').or('ROLE_OBSERVE').generate(),
    hasRoleViewer: new AclRule('ROLE_VIEWER').or('ROLE_ADMIN').or('ROLE_CENTER').or('ROLE_SUPERVISOR').or('ROLE_OBSERVE').or('ROLE_CONTRACTOR').generate(),
    isLogin: new AclRule('ROLE_VIEWER').generate(),
    hasRoleContractor: new AclRule('ROLE_ADMIN').or('ROLE_CENTER').or('ROLE_SUPERVISOR').or('ROLE_OBSERVE').or('ROLE_CONTRACTOR').generate(),
    hasRoleAdminOrContractor: new AclRule('ROLE_ADMIN').or('ROLE_CONTRACTOR').generate(),
    hasRoleOnlyContractor: new AclRule('ROLE_CONTRACTOR').generate(),

  },

  // middleware: async acl => {
  //   axios.get(API_BASE_URL+"api/me")
  //   .then(response =>{
  //       localStorage.setItem('exciseUserInfo', JSON.stringify(response.data));
  //       console.log(highestRole(response.data.roles));
  //       acl.change(highestRole(response.data.roles));
  //   })
  //   .catch(error =>{
  //       console.log('Error getting user profile on route change', error);
  //   });
  // }
})
